// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6 ? "150abb12" : chunkId) + "." + {"6":"68c7cb89a883cd19","268":"2285b89b860f1053","647":"ba10f080be318cc2"}[chunkId] + ".js";
};